import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'wfdss-export-button',
    templateUrl: './export-button.component.html',
    styleUrls: ['./export-button.component.scss'],
    standalone: false
})
export class ExportButtonComponent implements OnInit {
  /**@description Supply a string to show a tooltip on hover. */
  @Input() tooltip: false|string
  constructor() { }

  ngOnInit(): void {
  }

}
